var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 1v2h8V1h2v2h1c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H3a2 2 0 0 1-2-2l.01-12c0-1.1.88-2 1.99-2h1V1zm11 6H3v10h14zm-2 5v3h-3v-3z"
})));
export default SvgIconsEvent;